<template>
  <div class="newAgency">
    <el-row class="newAgency-title">
      <el-col :span="12">
        <p class="text">入驻申请-{{ title }}</p>
      </el-col>
      <!-- <el-col :span="12">
        <label>资料完整度{{percentage}}%</label>
        <div class="process">
          <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage" color="#3165FF"></el-progress>
        </div>
      </el-col> -->
      <el-row class="steps-row">
      <el-steps :active="activeStep" align-center>
        <el-step
          :title="item"
          description
          v-for="(item, index) of stepArr"
          :key="item"
          @click.native="toStep(index)"
        ></el-step>
      </el-steps>
    </el-row>
    </el-row>
    
    <step-com
      :myactiveStep="activeStep"
      @active="activeChange"
      :comArr="comArr"
      :title="title"
    ></step-com>
  </div>
</template>

<script>
import StepCom from "common/components/steps/stepItem";
const pathMgr = `FundManagement/components/newCom`;
const pathAgency = `FundAgency/components/newCom`;

const flags = {
  new: "新设",
  update: "变更",
  add: "迁入",
};

export default {
  components: {
    StepCom,
  },

  mounted() {
    this.title = flags[this.$route.query.flag];
  },

  data() {
    return {
      activeStep: 0,
      stepArr: ["基本信息", "出资人信息", "人员信息", "其他信息", "完成申请"],
      comArr: [
        `${pathAgency}/step1`,
        `${pathMgr}/step2`,
        `${pathMgr}/step3`,
        `${pathMgr}/step4`,
        `${pathMgr}/step5`,
      ],
      percentage: 80,
      title: "",
    };
  },
  methods: {
    toStep(index) {
      if (index >= this.activeStep) return;
      else {
        this.$confirm(
          "请确定已编辑的内容已经保存,避免已填写数据丢失, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            // this.returnBasic();
            this.activeStep = index;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    activeChange(ev) {
      this.activeStep = ev;
    },
  },
  watch: {
    $route(newValue) {
      this.title = flags[newValue.query.flag];
    },
  },
};
</script>

<style scoped>
.agency-title .text {
  font-size: 28px;
}
</style>
<style lang="scss" scoped>
.newAgency {
  height: 100%;
  // overflow: auto;
  display: flex;
  flex-direction: column;
  &-title {
    height: 220px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 4px 12px 0px #cccccc80;
    padding: 20px;
    display: flex;
    flex: 0 0 auto;
    // overflow: auto;
    flex-direction: column;
    .steps-row {
      height: 100%;
      padding-bottom: 15px;
      display: flex;
      // overflow: auto;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
}
</style>

